import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import SelectBox, { ToolbarItem } from 'devextreme-react/select-box';
import NumberBox from 'devextreme-react/number-box';
import Form, { CustomRule, Item, Label, RequiredRule } from 'devextreme-react/form';
import dxForm from 'devextreme/ui/form';
import axios from 'axios';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useAuth } from './../../../contexts/auth';
import { Button, LoadPanel, Popup, ScrollView, TextArea, TextBox } from 'devextreme-react';
import notify from 'devextreme/ui/notify';
import './bookingForm.scss';
import BookingDoc from './bookingDoc/bookingDoc';
import BookingChecklist from './bookingChecklist/bookingChecklist';
import { auth } from '../../../firebase';
import BookingInvoices from './bookingInvoices/bookingInvoices';

const BookingForm = () => {

  const baseUrl = process.env.REACT_APP_API_URL;

  const bookingFormRef = useRef<dxForm>(null);
  const [availableSlotsPerDay, setAvailableSlotsPerDay] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [userData, setUserData] = useState<any>(null);
  const [booking, setBooking] = useState<any>({});
  const [activeSlots, setActiveSlots] = useState<any[]>([]);
  const [statuses, setStatuses] = useState<any[]>([]);
  const [invoiceStatuses, setInvoiceStatuses] = useState<any[]>([]);
  const [vehicleTypes, setVehicleTypes] = useState<any[]>([]);
  const [conditions, setConditions] = useState<any[]>([]);
  const [devices, setDevices] = useState<any[]>([]);
  const [drivers, setDrivers] = useState<any[]>([]);
  const [costCenters, setCostCenters] = useState<any[]>([]);
  const [price, setPrice] = useState<any>();
  const [users, setUsers] = useState<any[]>([]);
  const [roles, setRoles] = useState<any[]>([]);
  const [tripDate, setTripDate] = useState('');
  const [slotTime, setSlotTime] = useState('');
  const [companies, setCompanies] = useState<any[]>([]);
  const [currentEditBooking, setCurrentEditBooking] = useState<any>({});
  const [popupVisible, setPopupVisible] = useState(false);
  const [rechungPopupVisible, setRechungPopupVisible] = useState(false);  
  const [isLoading, setIsLoading] = useState(false);
  const [orderReadyClicked, setOrderReadyClicked] = useState(false);
  const [bookingReadyPopupVisible, setBookingReadyPopupVisible] = useState(false);
  const [sendRechnungPopupVisible, setSendRechnungPopupVisible] = useState(false);
  const [sendRechnungConfirm, setSendRechnungConfirm] = useState(false);
  
  const [isEditMode, setIsEditMode] = useState<boolean>(false);
  const [isViewMode, setIsViewMode] = useState(false);
  const [isCopyMode, setIsCopyMode] = useState(false);

  const [isSaveClicked, setIsSaveClicked] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  const { user } = useAuth();
  const { id } = useParams<{ id: string }>();

  useEffect(() => {    
    // getUserData();
    // getBookingsById();
    setIsViewMode(location.pathname.includes('view'));
    setIsCopyMode(location.pathname.includes('copy'));
    setIsEditMode(location.pathname.includes('edit'));
    getActiveSlots();
    // getAvailableSlotsFor30Days();
    getVehicleTypes();
    getConditions();  
    getDevices();  
    getDrivers();  
    getCompanies();  
    getUsers();  
    getRoles();
    getStatuses();
    getInvoiceStatuses();
    getCostCenters();
  }, [userData]);

  useEffect(() => {
    getUserData();
    if(id) {
      getBooking();
    } 
    else {
      setBooking({});
    }
  }, [user]);

  const hidePopup = useCallback(() => {
    setPopupVisible(false);
  }, []);
  
  const hideRechnungPopup = useCallback(() => {
    setRechungPopupVisible(false);
  }, []);

  const getBooking = useCallback(() => {
    setLoading(true);
    axios.get(`${baseUrl}/api/Booking/booking?bookingId=${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
      }
    })
      .then(response => {
        if(!location.pathname.includes('copy')) {
          let totalTime = calculateTotalTime(response.data.data.pickUpTime, response.data.data.dropOffTime);  
          let totalKm = calculateTotalKm(response.data.data.pickupKmReading, response.data.data.dropOffKmReading);
          setTimeout(() => setBooking({ ...response.data.data, totalTime, totalKm }), 0);
          setTimeout(() => setSlotTime(response.data.data.slot.time), 1000);
          // setBooking(response.data.data);
          getAvailableSlotsPerDay(response.data.data.tripDate);
          // setSlotTime(response.data.data.slot.time);
        } else {        
          setBooking({
            ...response.data.data,
            id: null,
            bookingId: null,
            tripDate: null,
            slotId: null,
            slot: null,
            createdOn: null,
            updatedOn: null,
            deviceId: null,
            device: null,
            driverId: null,
            driver: null,
            statusId: null,
            status: null,
            invoices: null,
            priceNotExcl: null,
            priceExcl: null,
            driverRemarks: null,
            pickupKmReading: null,
            dropOffKmReading: null,
            pickUpConditionId: null,
            pickUpCondition: null,
            dropOffConditionId: null,
            dropOffCondition: null,
            pickUpTime: null,
            dropOffTime: null,   
            tripWeek: null,   
            trackingLink: null,
            internalNotes: null,                
            userId: userData?.id,
            user: {
              firstName: userData?.firstName,
              lastName: userData?.lastName,
              email: userData?.email,
              phoneNumber: userData?.phoneNumber
            }                        
          });
        }               
      })
      .catch(error => console.error('Error fetching booking:', error))
      .finally(() => setLoading(false));
  }, [userData]);

  const getAvailableSlotsPerDay = (date: any) => {
    setLoading(true);
    axios.get(`${baseUrl}/api/Booking/availableSlotsPerDay?tripDate=${date}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
      }
    })
      .then(response => {
        setAvailableSlotsPerDay(response.data.data);
      })
      .catch(error => console.error('Error fetching slots:', error))
      .finally(() => setLoading(false));
  };

  const getActiveSlots = () => {
    setLoading(true);
    axios.get(`${baseUrl}/api/StaticData/slots`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
      }
    })	
      .then(response => setActiveSlots(response.data.data))
      .catch(error => console.error('Error fetching slots:', error))
      .finally(() => setLoading(false));
  };

  const getVehicleTypes= () => {
    setLoading(true);
    axios.get(`${baseUrl}/api/StaticData/vehicleTypes`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
      }
    })
      .then(response => setVehicleTypes(response.data.data))
      .catch(error => console.error('Error fetching vehicle types:', error))
      .finally(() => setLoading(false));
  };

  const getConditions = () => {
    setLoading(true);
    axios.get(`${baseUrl}/api/StaticData/conditions`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
      }
    })
      .then(response => setConditions(response.data.data))
      .catch(error => console.error('Error fetching conditions:', error))
      .finally(() => setLoading(false));
  };

  const getDevices = () => {
    setLoading(true);
    axios.get(`${baseUrl}/api/StaticData/devices`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
      }
    })
      .then(response => setDevices(response.data.data))
      .catch(error => console.error('Error fetching devices:', error))
      .finally(() => setLoading(false));
  };

  const getDrivers = () => {
    setLoading(true);
    axios.get(`${baseUrl}/api/Driver/drivers`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
      }
    })
      .then(response => setDrivers(response.data.data))
      .catch(error => console.error('Error fetching drivers:', error))
      .finally(() => setLoading(false));
  };

  const getCompanies = () => {
    setLoading(true);
    axios.get(`${baseUrl}/api/StaticData/companies`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
      }
    })
      .then(response => {
        let companiesData = response.data.data;
        companiesData = isMoll() ? companiesData.filter((company: any) => company.code?.toLowerCase() === 'moll') : 
                        (isFex() ? companiesData.filter((company: any) => company.code?.toLowerCase() === 'fex') : companiesData);
        setCompanies(companiesData)
      })
      .catch(error => console.error('Error fetching companies:', error))
      .finally(() => setLoading(false));
  };

  const getUserData = () => {
    setLoading(true);
    const email = auth.currentUser?.email;
    axios.get(`${baseUrl}/api/User/userByEmail`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
      }
    })
      .then(response => setUserData(response.data.data))
      .catch(error => console.error('Error fetching users:', error))
      .finally(() => setLoading(false));
    };

  const getUsers = () => {
    setLoading(true);
    axios.get(`${baseUrl}/api/User/users`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
      }
    })
      .then(response => setUsers(response.data.data))
      .catch(error => console.error('Error fetching users:', error))
      .finally(() => setLoading(false));
  };

  const getRoles = () => {
    setLoading(true);
    axios.get(`${baseUrl}/api/User/roles`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
      }
    })
      .then(response => setRoles(response.data.data))
      .catch(error => console.error('Error fetching roles:', error))
      .finally(() => setLoading(false));
  };

  const getStatuses = () => {
    setLoading(true);
    axios.get(`${baseUrl}/api/StaticData/statuses`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
      }
    })
      .then(response => setStatuses(response.data.data))
      .catch(error => console.error('Error fetching statuses:', error))
      .finally(() => setLoading(false));
  };

  const getInvoiceStatuses = () => {
    setLoading(true);
    axios.get(`${baseUrl}/api/StaticData/invoiceStatuses`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
      }
    })
      .then(response => setInvoiceStatuses(response.data.data))
      .catch(error => console.error('Error fetching statuses:', error))
      .finally(() => setLoading(false));
  };

  const getCostCenters = () => {
    setLoading(true);
    axios.get(`${baseUrl}/api/StaticData/costCenters`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
      }
    })
      .then(response => setCostCenters(response.data.data))
      .catch(error => console.error('Error fetching costcenters:', error))
      .finally(() => setLoading(false));
  };

  const getPrice = () => {
    setLoading(true);
    let startKm = booking.pickupKmReading;
    let endKm = booking.dropOffKmReading;
    axios.get(`${baseUrl}/api/StaticData/price?startKM=${startKm}&endKM=${endKm}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
      }
    })
      .then(response => setPrice(response.data.data))
      .catch(error => console.error('Error fetching price:', error));
  };

  const onFormInitialized = useCallback((e: any) => {
    bookingFormRef.current = e.component;   
  }, []);  

  const costCenterCustomValidation = useCallback((e: any) => {
    return ((e.value === null || e.value === undefined || e.value === '') && booking?.costCenter?.name === 'Sonstiges' ) ? false : true
  },[booking]);

  const toast = useCallback((message: any, type: any = 'success') => {
    // console.log(message);
    notify({
      message: message,
      // position: {
      //   my: 'center top',
      //   at: 'center top',
      // },
    }, type, 3000);
  }, []);

  const handleBookingFormSave = useCallback((e: any) => {
    const validationResult = bookingFormRef.current?.validate();
    if (validationResult?.isValid) {
      setIsSaveClicked(true);
      setIsLoading(true);
      const upsertedBooking: any = {
        ...booking,
        companyId: booking?.company?.id,
        userId: (isEditMode || isViewMode) ? booking?.user?.id : userData?.id,
        deviceId: booking?.device?.id,
        vehicleTypeId: booking?.vehicleType?.id,
        driverId: booking?.driver?.id,
        pickUpConditionId: booking?.pickUpCondition?.id,
        dropOffConditionId: booking?.dropOffCondition?.id,
        costCenterId: booking?.costCenter?.id,
        slotId: booking?.slot?.id,
        statusId: (isEditMode || isViewMode) ? booking?.status?.id : 1,
        // invoiceStatusId: (isEditMode || isViewMode) ? booking?.invoiceStatus?.id : null,
        // invoiceNumber: (isEditMode || isViewMode) ? booking?.invoiceNumber : null,
        createdOn: (isEditMode || isViewMode) ? booking?.createdOn : getLocalISOString(),
        updatedOn: getLocalISOString(),
      };

      (async () => {
        try {
          (isEditMode || isViewMode) ? await updateBooking(upsertedBooking) : await addNewBooking(upsertedBooking);
          setIsSaveClicked(false);
          setIsLoading(false);
        } catch (error) {
          toast('Error', 'error');
          setIsSaveClicked(false);
          setIsLoading(false);
        }
      })();
    }
    e?.preventDefault();
  }, [booking, isSaveClicked]);

  const addNewBooking = async (booking: any) => {
    try {
      await axios.post(`${baseUrl}/api/Booking/addbooking`, booking, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('authToken')}`
        }
      }).then(response => {
          (isCopyMode) ? toast('Buchung erfolgreich kopiert', 'success') 
                        : toast('Buchung erfolgreich erstellt', 'success');
          navigate(`/bookings/edit/${response.data.data.id}`);   
        })              
    } catch (e: any) {
      (e?.status === 400) ?
      toast('Slot nicht mehr verfügbar. Bitte wählen Sie ein anderes Slot.', 'error') :
      toast('Buchung nicht erfolgreich erstellt', 'error');
    }
  }

  const updateBooking = async (booking: any) => {
    try {
      await axios.put(`${baseUrl}/api/Booking/updatebooking`, booking, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('authToken')}`
        }
      })
        .then(response => {
          toast('Buchung erfolgreich gespeichert', 'success');
          (isEditMode) && navigate(`/bookings/edit/${response.data.data.id}`);
          (isViewMode) && navigate(`/bookings/view/${response.data.data.id}`);
          let totalTime = calculateTotalTime(response.data.data.pickUpTime, response.data.data.dropOffTime);
          let totalKm = calculateTotalKm(response.data.data.pickupKmReading, response.data.data.dropOffKmReading);
          setTimeout(() => setBooking({ ...response.data.data, totalTime, totalKm }), 0);
        });      
    } catch (e: any) {
      console.error(e);
      (e?.status === 400) ?
      toast('Slot nicht mehr verfügbar. Bitte wählen Sie ein anderes Slot.', 'error') :
      toast('Buchung nicht erfolgreich gespeichert', 'error');
    }
  }

  const sendBookingReadyEmail = async () => {
    try {
      await axios.post(`${baseUrl}/api/Email/sendBookingReadyEmail`, booking, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('authToken')}`
        }
      }).then(response => {       
          toast('Buchungsbereit-Benachrichtigung gesendet', 'success');
      });      
    } catch (e: any) {
      console.error(e);
      toast('Fehler beim Senden der Benachrichtigung', 'error');
    }
  }

  const swapPickUpAndDropOffInfo = useCallback((e: any) => {    
    setBooking({ 
      ...booking,
      pickupLocNo: booking.dropOffLocNo,
      pickupLocStreet: booking.dropOffLocStreet,
      pickupLocPin: booking.dropOffLocPin,
      pickupLocCity: booking.dropOffLocCity,
      pickupContFirstName: booking.dropOffContFirstName,
      pickupContLastName: booking.dropOffContLastName,
      pickupContPhone: booking.dropOffContPhone,
      pickupContEmail: booking.dropOffContEmail,
      dropOffLocNo: booking.pickupLocNo,
      dropOffLocStreet: booking.pickupLocStreet,
      dropOffLocPin: booking.pickupLocPin,
      dropOffLocCity: booking.pickupLocCity,
      dropOffContFirstName: booking.pickupContFirstName,
      dropOffContLastName: booking.pickupContLastName,
      dropOffContPhone: booking.pickupContPhone,
      dropOffContEmail: booking.pickupContEmail,
    });
  }, [booking]);

  const getLocalISOString = (value: any = null) => {
    let date = (value !== null) ? new Date(value) : new Date();
    if (isNaN(date.getTime())) {
      console.error("Invalid date value:", value);
      return null;
    }
    const offset = date.getTimezoneOffset();
    const localDate = new Date(date.getTime() - (offset * 60000));
    return localDate.toISOString();
  };

  const onTripDateValueChanged = useCallback((e: any) => {
    if(e?.event === undefined) return; // if the event is undefined, it means the value is set programmatically
    const value = getLocalISOString(e?.value);
    getAvailableSlotsPerDay(value?.substring(0, 10));
    setBooking((prevBooking: any) => ({ ...prevBooking, tripDate: value }));
  }, []);

  const isAdmin = () => ((userData && userData.role) && (userData.role.name === 'Admin'));
  const isDriver = () => ((userData && userData.role) && (userData.role.name === 'Driver'));
  const isCustomer = () => ((userData && userData.role) && (userData.role.name === 'Customer'));
  const isDisponent = () => ((userData && userData.role) && (userData.role.name === 'Disponent'));
  const isMoll = () => ((userData && userData.role) && (userData.role.name === 'Moll'));
  const isFex = () => ((userData && userData.role) && (userData.role.name === 'Fex'));

  const displayDocPopup = useCallback(async (e: any) => {
    setPopupVisible(true);
  }, []);

  const displayRechnungPopup = useCallback(async (e: any) => {
    getPrice();
    setRechungPopupVisible(true);
  }, [booking]);

  const bookingReadyClicked = useCallback(() => {
    setBookingReadyPopupVisible(true);
  }, [bookingReadyPopupVisible]);

  const sendRechnungClicked = useCallback(() => {
    setSendRechnungPopupVisible(true);
  }, [sendRechnungPopupVisible]);

  const sendBookingReadyNotification = useCallback(() => {
    setOrderReadyClicked(true);
    setBookingReadyPopupVisible(false)
    sendBookingReadyEmail();
  }, [booking, orderReadyClicked]);

  const sendRechnungEmail = useCallback(() => {
    // setBooking({ ...booking, invoiceStatus: { ...invoiceStatuses.find((invoiceStatus) => invoiceStatus.name === 'Verarbeitung')}})   
    const verarbeitungStatus = invoiceStatuses.find(
      (s) => s.name === 'Verarbeitung'
    );
    
    if (!verarbeitungStatus) return;
    
    // Case 1: OriginalInvoice does not exist → set it
    if (booking.originalInvoice == null) {
      setBooking({
        ...booking,
        originalInvoice: {
          statusName: verarbeitungStatus.name,
          statusId: verarbeitungStatus.id
        }
      });
    }
    // Case 2: Original exists but Cancel does not → set CancelInvoice
    else if (booking.cancelInvoice == null) {
      setBooking({
        ...booking,
        cancelInvoice: {
          statusName: verarbeitungStatus.name,
          statusId: verarbeitungStatus.id
        }
      });
    }
    // Case 3: both exist → do nothing
    
    // handleBookingFormSave(null);
    setSendRechnungConfirm(true);
    setSendRechnungPopupVisible(false);
    setRechungPopupVisible(false);
    // sendBookingReadyEmail();
  }, [booking, sendRechnungClicked]);

  useEffect(() => {
    if (!sendRechnungConfirm) return;
    handleBookingFormSave(null);      
    setSendRechnungConfirm(false); // reset trigger
  }, [booking, sendRechnungConfirm]);

  const getBookingReadyButtonOptions = useMemo(() => ({
    icon: 'email',
    stylingMode: 'contained',
    type: 'default',
    text: 'Benachrichtigung senden!',
    onClick: sendBookingReadyNotification,
  }), [sendBookingReadyNotification]);

  const hideBookingReadyPopup = useCallback(() => {
    setBookingReadyPopupVisible(false);
  }, [setBookingReadyPopupVisible]);

  const getBookingReadyCloseButtonOptions = useMemo(() => ({
    text: 'Schließen',
    stylingMode: 'outlined',
    type: 'normal',
    onClick: hideBookingReadyPopup,
  }), [hideBookingReadyPopup]);

  const getSendRechnungButtonOptions = useMemo(() => ({
    icon: 'email',
    stylingMode: 'contained',
    type: 'default',
    text: 'Senden',
    onClick: sendRechnungEmail,
  }), [sendRechnungEmail]);

  const hideSendRechnungPopup = useCallback(() => {
    setSendRechnungPopupVisible(false);
  }, [setSendRechnungPopupVisible]);

  const getSendRechnungCloseButtonOptions = useMemo(() => ({
    text: 'Schließen',
    stylingMode: 'outlined',
    type: 'normal',
    onClick: hideSendRechnungPopup,
  }), [hideSendRechnungPopup]);

  const calculateTotalTime  = useCallback((pickUp: any, dropOff: any) => {
    if (!pickUp || !dropOff) return '';

    const start = new Date(pickUp);
    const end = new Date(dropOff);
    
    let diffMinutes = (end.getTime() - start.getTime()) / (1000 * 60);
    if (diffMinutes < 0) diffMinutes += 24 * 60; // handle overnight times
  
    const hours = Math.floor(diffMinutes / 60);
    const minutes = diffMinutes % 60;
    
    return `${hours}:${minutes < 10 ? '0' : ''}${minutes}`;
  }, []);

  const calculateTotalKm = useCallback((pickupKm: any, dropOffKm: any) => {
    if (pickupKm == null || dropOffKm == null || isNaN(pickupKm) || isNaN(dropOffKm)) return '';
  
    let diff = dropOffKm - pickupKm;
  
    // handle accidental negative values (e.g. user swaps them)
    if (diff < 0) diff = 0;
  
    return diff.toFixed(1).replace('.0', ''); // e.g., "75" instead of "75.0"
  }, []);

  let load1 = (isEditMode || isViewMode) && (!booking || !slotTime || Object.keys(booking).length === 0);
  let load2 = (isCopyMode) && (!booking || Object.keys(booking).length === 0);
  let load3 = !userData;

  if (load1 || load2 || load3 || isLoading) {
    return (
    <LoadPanel
      shadingColor="rgba(118, 205, 255, 0.12)"
      visible={true}
      showIndicator={true}
      showPane={true}
      message={isSaveClicked ? "Daten werden gespeichert..." : "Daten werden geladen..."}
    />);
  }

  return (
    <ScrollView>
      <Popup        
        maxHeight={'100vh'}
        hideOnOutsideClick={false}
        showCloseButton={true}
        title={'Übergabeprotokoll'}
        visible={popupVisible}
        onHiding={hidePopup}
        className="doc-popup-content">
          <BookingChecklist bookings={[{
            tripDate: booking?.tripDate?.split('T')[0] || '',
            slot: '',
            bookingID: booking?.bookingId || '',
            vehicleInfo: ` ${booking?.brand || ''} ${booking?.model || ''} ${booking?.color || ''} ${booking?.vehicleType?.type || ''}`,
            licensePlate: booking?.licensePlate || '',
            pickupAddress: `${booking?.pickupLocStreet || ''} ${booking?.pickupLocNo || ''}, ${booking?.pickupLocPin || ''} ${booking?.pickupLocCity || ''}`,
            dropOffAddress: `${booking?.dropOffLocStreet || ''} ${booking?.dropOffLocNo || ''}, ${booking?.dropOffLocPin || ''} ${booking?.dropOffLocCity || ''}`,
            pickupTime: booking?.slot?.time || '',
            dropOffTime: booking?.dropOffTime || '',
            notes: booking?.notes || '',
          }]} />
      </Popup>  
      <Popup
        maxHeight={'100vh'}
        hideOnOutsideClick={false}
        showCloseButton={true}
        title={'Rechnung'}
        visible={rechungPopupVisible}
        onHiding={hideRechnungPopup}
        className="doc-popup-content"
        toolbarItems={[
          {
            widget: 'dxButton',
            location: 'center',
            toolbar: 'top',
            options: {
              icon: 'email',
              text: 'Rechnung an den Kunden',
              stylingMode: 'contained',
              type: 'normal',
              onClick: () => sendRechnungClicked()
            }
          }
        ]}>
      </Popup>  
      <Popup
        visible={sendRechnungPopupVisible}
        dragEnabled={false}
        hideOnOutsideClick={false}
        showCloseButton={false}
        showTitle={true}
        title="!!!Achtung!!! - Haben Sie alle Daten überprüft?"
        container=".dx-viewport"
        width={500}
        height={240}
      >
        ------------------------------------------------------------------------------<br />
        - Die Rechnung wird dem Kunden zugesandt.<br />
        ------------------------------------------------------------------------------<br />
        - Die Rechnungsnummer wird generiert/mit der Buchung verknüpft.<br />
        ------------------------------------------------------------------------------<br />
        <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="before"
          options={getSendRechnungButtonOptions}
        />
        <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          options={getSendRechnungCloseButtonOptions}
        />
      </Popup>
      <Popup
        visible={bookingReadyPopupVisible}
        dragEnabled={false}
        hideOnOutsideClick={false}
        showCloseButton={false}
        showTitle={true}
        title="Ist die Buchung zur Abholung bereit?"
        container=".dx-viewport"
        width={500}
        height={130}
      >
        <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="before"
          options={getBookingReadyButtonOptions}
        />
        <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          options={getBookingReadyCloseButtonOptions}
        />
      </Popup>
      <div className="booking-form-content-block">
        <div className="dx-card responsive-paddings">
          <h6 className="content-block-header" style={{marginTop: '0px', marginBottom: '20px', textAlign: 'center'}}>Buchungsformular</h6>
          <div id="booking-form-container">   
          {/* <button onClick={() => navigate('/bookings')} style={{ marginBottom: '10px' }}>
            <h6 style={{ margin: '0px' }}>← zurück zu Buchungen</h6>
          </button> */}
          <form action="your-action" onSubmit={handleBookingFormSave}>
            <Form 
              id="booking-form"
              formData={booking}
              onInitialized={onFormInitialized}>
              <Item itemType="group" colCount={3} colSpan={2}>
                {/* Toolbar */}
                <Item itemType="group"colCount={12} colSpan={3} cssClass="form-toolbar">
                  <Item colSpan={2}>
                    <Button
                      width={200}
                      text="← zurück zu Buchungen"
                      type="default"
                      stylingMode="outlined"
                      onClick={() => navigate('/bookings')}
                    />
                  </Item>
                  {/* <Item itemType='empty' colSpan={1}/> */}
                  <Item colSpan={2} disabled={orderReadyClicked}>
                    {(booking?.status?.name?.toLowerCase() === 'ausstehend') && (isEditMode || isViewMode) ? (
                      <Button
                      width={180}
                      text="Abholungsbereit"
                      type="normal"
                      stylingMode="contained"
                      icon="send"
                      onClick={bookingReadyClicked}
                      />
                    ) : (
                      <Item itemType="empty" />
                    )}
                  </Item>
                  {/* <Item itemType="empty" /> */}
                  <Item colSpan={2} disabled={isViewMode}>
                    <Button
                      width={150}
                      text="Abhol ⇄ Abgabe"
                      type="normal"
                      stylingMode="contained"
                      onClick={swapPickUpAndDropOffInfo}
                    />
                  </Item>    
                  {/* <Item itemType='empty' colSpan={1}/> */}
                  <Item colSpan={2}>
                    {(isEditMode || isViewMode) ? (
                      <Button
                        width={180}
                        text="Übergabe"
                        type="normal"
                        stylingMode="contained"
                        icon="pdffile"
                        onClick={displayDocPopup}
                      />
                    ) : (
                      <Item itemType="empty" />
                    )}
                  </Item>   
                  <Item colSpan={2}>
                    {/* {isAdmin() &&
                    (isEditMode || isViewMode) &&
                    // booking.invoiceNumber === null &&
                    (booking?.originalInvoice === null || booking?.cancelInvoice === null) &&
                    // booking?.invoiceStatus?.name !== 'Storniert' &&
                    ["Abgeschlossen", "Storno", "Leerfahrt"].includes(booking.status?.name || "") &&
                    booking.pickupKmReading !== null &&
                    booking.dropOffKmReading !== null ? (
                      <Button
                        width={180}
                        text={booking?.originalInvoice === null  ? "Rechnung" : "Stornierungsrechnung"}
                        type="normal"
                        stylingMode="contained"
                        icon="money"
                        onClick={displayRechnungPopup}
                      />
                    ) : ( */}
                      <Item itemType="empty" />
                    {/* // )} */}
                  </Item>             
                  <Item colSpan={2} disabled={isViewMode || isSaveClicked}>
                    <Button
                      width={200}
                      text="Speichern"
                      type="default"
                      stylingMode="contained"
                      useSubmitBehavior={true}
                    />
                  </Item>
                </Item>
                {/* Basic Information */}
                <Item itemType="group" caption="Basisinformationen" colCount={6} colSpan={1} disabled={isViewMode}>
                  <Item dataField="bookingId" disabled={true} colSpan={3}>
                    <Label text="Buchungs-ID" />
                  </Item>
                  <Item dataField="company.name" colSpan={3}
                    isRequired={true}
                    editorType="dxSelectBox"
                    editorOptions={{
                      items: companies,
                      displayExpr: "name",
                      valueExpr: "name",
                      placeholder: "Select Company",
                      onValueChanged: (e: any) => setBooking({ ...booking, company: { ...companies.find((company) => company.name === e.value)}})                      
                    }}>
                    <Label text="Firma" />
                    <RequiredRule />
                  </Item>
                  <Item dataField="costCenter.name" colSpan={3}
                    isRequired={true}
                    editorType="dxSelectBox"
                    visible={booking?.company?.code?.toLowerCase() === 'moll'}
                    editorOptions={{
                      items: costCenters,
                      displayExpr: "name",
                      valueExpr: "name",
                      placeholder: "Kostenstelle",
                      onValueChanged: (e: any) => setBooking({ ...booking, costCenter: { ...costCenters.find((costCenter) => costCenter.name === e.value)}})                      
                    }}>
                    <Label text="Kostenstelle" />
                    <RequiredRule />
                  </Item>
                  <Item dataField="costCenterCustom" colSpan={3} visible={booking?.company?.code?.toLowerCase() === 'moll'}> 
                    <Label text="Sonstige Kostenstelle" />
                    <CustomRule reevaluate={true} validationCallback={costCenterCustomValidation} message="Erforderlich bei Kostenstelle 'Sonstiges'" />  
                  </Item>             
                  <Item dataField="tripDate" colSpan={3} disabled={false} isRequired={true}
                    editorType="dxDateBox"
                    editorOptions={{
                      displayExpr: "time",
                      valueExpr: "time",
                      displayFormat: "dd.MM.yyyy",
                      type: "date",
                      placeholder: "Liefertermin",
                      disabledDates: (args: any) =>  args.date < new Date().setHours(0, 0, 0, 0),
                      onValueChanged: (e: any) => onTripDateValueChanged(e)
                    }}>
                    <Label text="Liefertermin" />
                    <RequiredRule message="Liefertermin und LieferZeit is required" />
                  </Item>    
                  <Item dataField="slot.time" colSpan={2} disabled={false}
                    isRequired={true}
                    editorType="dxSelectBox"
                    editorOptions={{
                      items: availableSlotsPerDay,
                      displayExpr: "time",
                      valueExpr: "time",
                      placeholder: "Slot",
                      value: slotTime,
                      onValueChanged: (e: any) => {
                        setBooking({ ...booking, slot: { ...availableSlotsPerDay.find((slot) => slot.time === e.value)}})
                        setSlotTime(e.value)
                      } 
                    }}>
                    <Label text="Slot" />
                    <RequiredRule />
                  </Item>  
                  {/* <Item dataField="slot.time" colSpan={2} disabled={true}>
                    <Label text="Slot" />
                  </Item>   */}
                  <Item dataField="tripWeek" colSpan={1} disabled={true}>
                    <Label text="KW" />
                  </Item>                                                      
                </Item>

                {/* Pickup Information */}
                <Item itemType="group" caption="Abholinformationen" colCount={2} colSpan={2} disabled={isViewMode}>
                  <Item itemType="group" caption="Ort" colCount={2} colSpan={1}>
                    <Item dataField="pickupLocStreet">
                      <Label text="Straße" />
                      <RequiredRule />
                    </Item> 
                    <Item dataField="pickupLocNo">
                      <Label text="Haus-Nr" />
                      <RequiredRule />
                      <CustomRule 
                        validationCallback={(e: any) => e.value?.length <= 10} 
                        message="Haus-Nr darf maximal 10 Zeichen lang sein" 
                      />
                    </Item> 
                    <Item dataField="pickupLocPin">
                      <Label text="Postleitzahl" />
                      <RequiredRule />
                    </Item> 
                    <Item dataField="pickupLocCity">
                      <Label text="Standort" />
                      <RequiredRule />
                    </Item> 
                  </Item>
                  <Item itemType="group" caption="Kontakt" colCount={2} colSpan={1}>
                    <Item dataField="pickupContFirstName">
                      <Label text="Vorname" />
                      <RequiredRule />
                    </Item> 
                    <Item dataField="pickupContLastName">
                      <Label text="Nachname" />
                      <RequiredRule />
                    </Item> 
                    <Item dataField="pickupContPhone">
                      <Label text="Telefon" />
                      <RequiredRule />
                    </Item> 
                    <Item dataField="pickupContEmail">
                      <Label text="Email" />
                      <RequiredRule />
                    </Item> 
                  </Item>
                </Item>
                
                {/* Vehicle Information */}
                <Item itemType="group" caption="Fahrzeuginformationen" colCount={2} colSpan={1} disabled={isViewMode}>
                  <Item dataField="brand" colSpan={1}>
                    <Label text="Marke" />
                  </Item> 
                  <Item dataField="model" colSpan={1}>
                    <Label text="Modell" />
                  </Item> 
                  <Item dataField="vehicleType.type" colSpan={1}>
                    <Label text="Auto Typ" />
                      <SelectBox 
                        items={vehicleTypes}
                        placeholder="Typ"	
                        displayExpr="type"
                        valueExpr="type"
                        value={booking?.vehicleType?.type}
                        onValueChanged={(e) => setBooking({ ...booking, vehicleType: vehicleTypes.find((type) => type.type === e.value) })}
                      ></SelectBox>
                  </Item>
                  <Item dataField="color" colSpan={1}>
                    <Label text="Farbe" />
                  </Item> 
                  <Item dataField="licensePlate" colSpan={1}>
                    <Label text="Kennenzeichnen / FIN" />
                    <RequiredRule />
                  </Item> 
                  <Item dataField="trackingLink"
                    label={{ text: "Tracking Link" }}
                    editorType="dxTextBox"
                    editorOptions={{
                      value: booking?.trackingLink,
                      onValueChanged: (e: any) => {
                        const input = e.value;
                        const match = input?.match(/(https?:\/\/[^\s]+)/);
                        const validUrl = match ? match[0] : '';
                        setBooking({ ...booking, trackingLink: validUrl });
                      },
                      buttons: [{
                        name: "openLink",
                        location: "after",
                        options: {
                          icon: "link",
                          stylingMode: "text",
                          disabled: !booking?.trackingLink,
                          onClick: () => {
                            if (booking.trackingLink) {
                              window.open(booking?.trackingLink, "_blank", "noopener,noreferrer");
                            }
                          },
                          hint: "Link öffnen"
                        }
                      }]
                    }}
                  />
                </Item>

                {/* Drop-off Information */}
                <Item itemType="group" caption="Abgabeinformationen" colCount={2} colSpan={2} disabled={isViewMode}>
                  <Item itemType="group" caption="Ort" colCount={2} colSpan={1}>
                    <Item dataField="dropOffLocStreet">
                      <Label text="Straße" />
                      <RequiredRule />
                    </Item> 
                    <Item dataField="dropOffLocNo">
                      <Label text="Haus-Nr" />
                      <RequiredRule />
                      <CustomRule 
                        validationCallback={(e: any) => e.value?.length <= 10} 
                        message="Haus-Nr darf maximal 10 Zeichen lang sein" 
                      />
                    </Item> 
                    <Item dataField="dropOffLocPin">
                      <Label text="Postleitzahl" />
                      <RequiredRule />
                    </Item> 
                    <Item dataField="dropOffLocCity">
                      <Label text="Standort" />
                      <RequiredRule />
                    </Item> 
                  </Item>
                  <Item itemType="group" caption="Kontakt" colCount={2} colSpan={1}>
                    <Item dataField="dropOffContFirstName">
                      <Label text="Vorname" />
                      <RequiredRule />
                    </Item> 
                    <Item dataField="dropOffContLastName">
                      <Label text="Nachname" />
                      <RequiredRule />
                    </Item> 
                    <Item dataField="dropOffContPhone">
                      <Label text="Telefon" />
                      <RequiredRule />
                    </Item> 
                    <Item dataField="dropOffContEmail">
                      <Label text="Email" />
                      <RequiredRule />
                    </Item> 
                  </Item>
                </Item>

                {/* User Information */}
                <Item itemType="group" caption="Benutzerinformationen" colCount={2} colSpan={1} disabled={isViewMode}>
                  <Item dataField="user.email" disabled={true}>
                    <Label text="Email" />
                  </Item> 
                  <Item dataField="user.firstName" disabled={true}>
                    <Label text="Vorname" />
                  </Item> 
                  <Item dataField="user.lastName" disabled={true}>
                    <Label text="Nachname" />
                  </Item> 
                  <Item dataField="user.phoneNumber" disabled={true}>
                    <Label text="Telefon" />
                  </Item> 
                  <Item dataField="notes" colSpan={2}>
                    <Label text="Benutzer Hinweis" />
                  </Item> 
                </Item>

                {/* Assignment Information */}
                <Item itemType="group" caption="Abtretung" colCount={2} colSpan={1} disabled={isViewMode}>
                  <Item dataField="device.name" visible={isAdmin() || isDisponent() || isDriver()}>
                    <Label text="Gerät" />
                    <SelectBox 
                      items={devices}
                      placeholder="Gerät"
                      displayExpr="name"
                      valueExpr="name"
                      value={booking?.device?.name}
                      onValueChanged={(e) => setBooking({ ...booking, device: devices.find((device) => device.name === e.value) })}
                    ></SelectBox>
                  </Item> 
                  <Item dataField="driver.driverId" visible={isAdmin() || isDisponent() || isDriver()} >
                    <Label text="Fahrer ID" />
                    <SelectBox 
                      items={drivers}
                      placeholder="Fahrer"
                      displayExpr="driverId"
                      valueExpr="driverId"
                      value={booking?.driver?.driverId}
                      onValueChanged={(e) => setBooking({ ...booking, driver: drivers.find((driver) => driver.driverId === e.value) })}
                    ></SelectBox>
                  </Item> 
                  <Item dataField="driverRemarks" colSpan={2} disabled={!(isAdmin() || isDisponent() || isDriver())}>
                    <Label text="Fahrer Hinweis" />
                    <TextArea
                      value={booking?.driverRemarks}
                      onValueChanged={(e) =>
                        setBooking({ ...booking, driverRemarks: e.value })
                      }
                      autoResizeEnabled={true}
                      minHeight={30}
                    />
                  </Item> 
                  <Item dataField="internalNotes" colSpan={2} visible={isAdmin() || isDisponent() || isDriver()}>
                    <Label text="Interne Notizen (Hinweis auf der Rechnung*)" />
                    <TextArea
                      value={booking?.internalNotes}
                      onValueChanged={(e) =>
                        setBooking({ ...booking, internalNotes: e.value })
                      }
                      autoResizeEnabled={true}
                      minHeight={30}
                    />
                  </Item> 
                </Item>

                {/* Trip Details */}
                <Item itemType="group" caption="Lieferinformationen" colCount={6} colSpan={1} visible={isAdmin() || isDisponent() || isDriver()} disabled={isViewMode}>
                <Item dataField="pickUpCondition.name" colSpan={3}>
                    <Label text="Abholzustand" />
                    <SelectBox 
                      items={conditions}
                      placeholder="Zustand"
                      displayExpr="name"
                      valueExpr="name"
                      value={booking?.pickUpCondition?.name}
                      onValueChanged={(e) => setBooking({ ...booking, pickUpCondition: conditions.find((condition) => condition.name === e.value) })}
                    ></SelectBox>
                  </Item> 
                  <Item dataField="dropOffCondition.name" colSpan={3}>
                    <Label text="Abgabezustand" />
                    <SelectBox 
                      items={conditions}
                      placeholder="Zustand"
                      displayExpr="name"
                      valueExpr="name"
                      value={booking?.dropOffCondition?.name}
                      onValueChanged={(e) => setBooking({ ...booking, dropOffCondition: conditions.find((condition) => condition.name === e.value) })}
                    ></SelectBox>
                  </Item> 
                  <Item dataField="pickUpTime" colSpan={2}>
                    <Label text="Abholzeit" />
                    <SelectBox
                      items={Array.from({ length: 288 }, (_, i) => {
                        const hours = String(Math.floor(i / 12)).padStart(2, '0');
                        const minutes = String((i % 12) * 5).padStart(2, '0');
                        return { time: `${hours}:${minutes}` };
                      })}
                      displayExpr="time"
                      valueExpr="time"
                      searchEnabled={true}
                      defaultValue={booking?.pickUpTime?.slice(11, 16)}
                      // onValueChanged={(e) => (e.event) && setBooking({ ...booking, pickUpTime: `1900-01-01T${e.value}` })}
                      onValueChanged={(e) => {
                        if (e.event) {
                          let totalTime = calculateTotalTime(`1900-01-01T${e.value}`, booking.dropOffTime);
                          setBooking({ ...booking, pickUpTime: `1900-01-01T${e.value}`, totalTime: totalTime });
                        }
                      }}
                    />
                  </Item>
                  <Item dataField="totalTime" colSpan={2}>
                    <Label text="Gesamtzeit" />
                    <TextBox 
                      readOnly={true}
                      value={booking?.totalTime || ''}
                    />
                  </Item>
                  <Item dataField="dropOffTime" colSpan={2}>
                    <Label text="Abgabezeit" />
                    <SelectBox
                      items={Array.from({ length: 288 }, (_, i) => {
                        const hours = String(Math.floor(i / 12)).padStart(2, '0');
                        const minutes = String((i % 12) * 5).padStart(2, '0');
                        return { time: `${hours}:${minutes}` };
                      })}
                      displayExpr="time"
                      valueExpr="time"
                      searchEnabled={true}
                      defaultValue={booking?.dropOffTime?.slice(11, 16)}
                      // onValueChanged={(e) => (e.event) && setBooking({ ...booking, dropOffTime: `1900-01-01T${e.value}` })}
                      onValueChanged={(e) => {
                        if (e.event) {
                          let totalTime = calculateTotalTime(booking.pickUpTime, `1900-01-01T${e.value}`);
                          setBooking({ ...booking, dropOffTime: `1900-01-01T${e.value}`, totalTime: totalTime });
                        }
                      }}
                    />
                  </Item>
                  <Item dataField="pickupKmReading" colSpan={2}>
                    <Label text="Abholung Kilometerstand" />
                    <NumberBox
                      defaultValue={booking?.pickupKmReading}                  
                      showSpinButtons={true}
                      showClearButton={true}
                      // onValueChanged={(e) => setBooking({ ...booking, pickupKmReading: e.value })}
                      onValueChanged={(e) => {
                        if (e.event) {
                          let totalKm = calculateTotalKm(e.value, booking.dropOffKmReading);
                          setBooking({ ...booking, pickupKmReading: e.value, totalKm: totalKm });
                        }
                      }}
                    />
                  </Item>
                  <Item dataField="totalKm" colSpan={2}>
                    <Label text="Gesamtkilometer" />
                    <TextBox 
                      readOnly={true}
                      value={booking?.totalKm || ''}
                    />
                  </Item>
                  <Item dataField="dropOffKmReading" colSpan={2}>
                    <Label text="Abgabe Kilometerstand" />
                    <NumberBox
                      defaultValue={booking?.dropOffKmReading}                  
                      showSpinButtons={true}
                      showClearButton={true}
                      // onValueChanged={(e) => setBooking({ ...booking, dropOffKmReading: e.value })}
                      onValueChanged={(e) => {
                        if (e.event) {
                          let totalKm = calculateTotalKm(booking.pickupKmReading, e.value);
                          setBooking({ ...booking, dropOffKmReading: e.value, totalKm: totalKm });
                        }
                      }}
                    />
                  </Item>
                </Item>

                {/* Additional Information */}
                <Item itemType="group"  caption="Weitere Informationen" colCount={2} colSpan={1} disabled={true}>
                  {/* <Item dataField="year" /> */}
                  <Item dataField="createdOn">
                    <Label text="Erstellt am" />
                  </Item> 
                  <Item dataField="updatedOn">
                    <Label text="Aktualisiert am" />
                  </Item> 
                </Item>

                {/* Status */}
                <Item itemType="group" caption="Status" colCount={1} colSpan={1} disabled={!(isAdmin() || isDisponent())}>
                  <Item dataField="status.name" colSpan={1}>
                    <Label text="Status" />
                    <SelectBox 
                      items={statuses}
                      placeholder="Status"
                      displayExpr="name"
                      valueExpr="name"
                      value={booking?.status?.name}
                      onValueChanged={(e) => setBooking({ ...booking, status: statuses.find((status) => status.name === e.value) })}
                    ></SelectBox>
                  </Item>
                </Item>
              </Item>
              {/* Financial Information */}
              <Item itemType="group" caption="Kosteninformationen" colCount={1} colSpan={1} visible={isAdmin()} disabled={isViewMode}>
                <Item visible={isAdmin()} colSpan={1}>
                  <BookingInvoices bookingId={booking?.id} />
                </Item> 
              </Item>
              <Item itemType="group" caption="Unterlagen" visible={isEditMode || isViewMode}>
                <Item disabled={false}>
                  <BookingDoc id={booking?.bookingId} user={userData} />
                </Item>
              </Item>
            </Form> 
          </form>     
        </div>
        </div>
      </div>
    </ScrollView>
  );
};

export default BookingForm;
